
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getExif"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "00c404b58853ebbb.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "00c404b58853ebbb.worker.js");
					addMethods(w, methods)
					
					return w
				}
			